<template>
    <div class="bg-white px-6 py-4 my-4 min-w-[500px] mr-16 xs:!mr-0 w-full">
        <strong>No Reports.</strong>
    </div>  
</template>
